import React, { useEffect, useRef, useState, useCallback, memo } from 'react';
import cls from 'classnames';
import styles from './index.module.scss';
import { getNoticeList } from '@/apis';
import { useQuery } from '@tanstack/react-query';
import Icon from '@/components/Icon';
import { requestAnimation } from '@/utils';

const Notice: React.FC = () => {
  const dom = useRef<HTMLDivElement>(null);
  const distance = useRef<number>(0);
  const animateDis = useRef<number>(0);
  const [animateStyle, setAnimateStyle] = useState({});
  const { data } = useQuery([getNoticeList.name], async () => {
    const res = await getNoticeList({
      page: 1,
      page_size: 200,
    });
    if (res && res.data && res.data.length) {
      const date = Date.now();
      const span = `<span class=${styles.gap}></span>`;
      return res.data
        ?.filter((item) => item.start_time! < date && item.end_time! > date)
        .map((item) => item.msg)
        .join(span);
    }
    return '';
  });
  const beginAnimation = useCallback(() => {
    animateDis.current += 1.8;
    if (animateDis.current < distance.current) {
      setAnimateStyle({
        transform: `translate3d(-${animateDis.current}px, 0, 0)`,
        transitionDuration: '1s',
      });
      requestAnimation(beginAnimation.bind(this));
    } else {
      animateDis.current = 0;
      setAnimateStyle({
        transform: `translate3d(-${animateDis.current}px, 0, 0)`,
        transitionDuration: '0s',
      });
      setTimeout(() => {
        requestAnimation(beginAnimation.bind(this));
      }, 3000);
    }
  }, []);
  useEffect(() => {
    if (!!data && dom.current) {
      distance.current = dom.current.scrollWidth!;
      setTimeout(() => {
        requestAnimation(beginAnimation.bind(this));
      }, 3000);
    }
  }, [data, beginAnimation]);
  if (!data) return null;
  return (
    <div className={cls(styles.notice, 'animate__hex', 'animate__fadeIn')}>
      <p ref={dom} className={styles.main} style={animateStyle}>
        <Icon id="#hxicon-notice" className={styles.icon} />
        <span dangerouslySetInnerHTML={{ __html: data }}></span>
      </p>
    </div>
  );
};

export default memo(Notice);
